import { Component, inject } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-report-order',
  templateUrl: './report-order.component.html',
  styleUrls: ['./report-order.component.css']
})
export class ReportOrderComponent {
  private global = inject(GlobalService)
  constructor(){
    this.global.PermissionsMenu('ordenes_cofirmadas_submenu')
  }

}
